import React from 'react';
import { useContext } from 'react';
import { LoginContext } from '../../AuthContext/LoginContext';

const ProfileNav = (props) => {
  const {loginData}=useContext(LoginContext);
  return (
    <nav className="flex items-center justify-center p-4 bg-black text-white">
      <div className="flex items-center space-x-4">
        <div className="text-white hover:text-gray-300" onClick={()=>props.setter(1)}>Profile</div>
        {loginData.isAdmin && <div className="text-white hover:text-gray-300" onClick={()=>props.setter(2)}>All Orders</div>}
        {loginData.isAdmin && <div className="text-white hover:text-gray-300" onClick={()=>props.setter(3)}>Products</div>}
        {!loginData.isAdmin && <div className="text-white hover:text-gray-300" onClick={()=>props.setter(4)}>Your Orders</div>}
      </div>
    </nav>
  );
};

export default ProfileNav;
